/*
 *
 * Do not edit directly
 * Generated on Fri, 14 Feb 2025 18:58:13 GMT
 *
 */


const theme = {
  appearances: {
    bold: {
      description: 'Sets the font weight, to bold on some body text styles. Does not change accessibility properties.',
      type: 'variant',
      values: [ true ]
    },
    colour: {
      description: 'Each typography variant has a default color, and at least a secondary color variant. In exceptional cases where a different colour is needed,\n' +
        '  use the tokens prop.',
      type: 'variant',
      values: [
        'default',      'brand',
        'dark',         'light',
        'positive',     'warning',
        'danger',       'black',
        'white',        'brand2',
        'brand3',       'alternative1',
        'alternative2', 'alternative3'
      ]
    },
    compact: {
      description: 'Reduces line height on some body text styles. For data-rich content, not for flow content',
      type: 'variant',
      values: [ true ]
    },
    inverse: {
      description: 'Styles the link white for use on dark backgrounds.',
      type: 'variant',
      values: [ true ]
    },
    size: {
      type: 'variant',
      values: [
        'micro',    'small',
        'large',    'h1',
        'h2',       'h3',
        'h4',       'h5',
        'h6',       'display1',
        'display2', 'eyebrow'
      ]
    },
    viewport: {
      description: 'The size label for the current screen viewport based on the current screen width',
      type: 'state',
      values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
    },
    weight: {
      description: 'Sets the font weight, default is regular 400 weight. Does not change accessibility properties.',
      type: 'variant',
      values: [ 'semibold', 'bold' ]
    }
  },
  rules: [
    {
      if: { compact: true, size: 'large' },
      tokens: { lineHeight: 1.4 }
    },
    {
      description: "The compact line height for the 'default' font size, but doesn't apply for any other styles",
      if: { compact: true, size: null },
      tokens: { lineHeight: 1.55555555 }
    },
    {
      if: { compact: true, size: 'small' },
      tokens: { lineHeight: 1.5 }
    },
    { if: { inverse: true }, tokens: { color: '#ffffff' } },
    {
      description: 'Please only bold single words while using with headings',
      if: { bold: true, size: [ 'h1', 'h2', 'display1', 'display2' ] },
      tokens: { fontName: 'BystanderSans', fontWeight: '700' }
    },
    {
      description: 'Please only bold single words while using with headings',
      if: {
        bold: true,
        size: [
          'micro', 'small',
          'large', 'h3',
          'h4',    'h5',
          'h6'
        ]
      },
      tokens: { fontName: 'SofiaPro', fontWeight: '700' }
    },
    {
      if: { size: 'display1' },
      tokens: {
        fontName: 'BystanderSans',
        fontSize: 72,
        fontWeight: '700',
        lineHeight: 1.22222222222
      }
    },
    {
      if: { size: 'display2' },
      tokens: {
        fontName: 'BystanderSans',
        fontSize: 64,
        fontWeight: '700',
        lineHeight: 1.125
      }
    },
    {
      if: { size: 'large' },
      tokens: { fontSize: 20, lineHeight: 1.4 }
    },
    {
      if: { size: 'eyebrow' },
      tokens: {
        color: '#394056',
        fontName: 'SofiaPro',
        fontSize: 16,
        fontWeight: '700',
        lineHeight: 1.5,
        textTransform: 'uppercase'
      }
    },
    {
      if: { size: 'small' },
      tokens: { fontSize: 16, lineHeight: 1.5 }
    },
    {
      if: { size: 'micro' },
      tokens: { fontSize: 14, lineHeight: 1.4285714285714286 }
    },
    {
      if: { size: 'h1' },
      tokens: {
        fontName: 'BystanderSans',
        fontSize: 48,
        fontWeight: '700',
        lineHeight: 1
      }
    },
    {
      if: { size: 'h1', viewport: [ 'lg', 'xl' ] },
      tokens: { lineHeight: 1.125 }
    },
    {
      if: { size: 'h2' },
      tokens: {
        fontName: 'BystanderSans',
        fontSize: 36,
        fontWeight: '700',
        lineHeight: 1.22222222222
      }
    },
    {
      if: { size: 'h2', viewport: [ 'lg', 'xl' ] },
      tokens: { lineHeight: 1.3333333333333333 }
    },
    {
      if: { size: 'h3' },
      tokens: {
        fontName: 'SofiaPro',
        fontSize: 30,
        fontWeight: '700',
        lineHeight: 1.2
      }
    },
    {
      if: { size: 'h4' },
      tokens: {
        fontName: 'SofiaPro',
        fontSize: 24,
        fontWeight: '400',
        lineHeight: 1.3333333333333333
      }
    },
    {
      if: { size: 'h5' },
      tokens: {
        fontName: 'SofiaPro',
        fontSize: 20,
        fontWeight: '700',
        lineHeight: 1.4
      }
    },
    {
      if: { size: 'h6' },
      tokens: {
        fontName: 'SofiaPro',
        fontSize: 16,
        fontWeight: '700',
        lineHeight: 1.5
      }
    },
    {
      if: { weight: 'semibold' },
      tokens: { fontName: 'SofiaPro', fontWeight: '700' }
    },
    {
      if: { weight: 'bold' },
      tokens: { fontName: 'SofiaPro', fontWeight: '700' }
    },
    {
      if: { bold: true },
      tokens: { fontName: 'SofiaPro', fontWeight: '700' }
    },
    { if: { colour: 'default' }, tokens: { color: '#394056' } },
    { if: { colour: 'brand' }, tokens: { color: '#394056' } },
    { if: { colour: 'dark' }, tokens: { color: '#2b3145' } },
    { if: { colour: 'light' }, tokens: { color: '#6a7080' } },
    { if: { colour: 'positive' }, tokens: { color: '#2b826e' } },
    { if: { colour: 'warning' }, tokens: { color: '#f39d80' } },
    { if: { colour: 'danger' }, tokens: { color: '#bf1722' } },
    { if: { colour: 'black' }, tokens: { color: '#000000' } },
    { if: { colour: 'white' }, tokens: { color: '#ffffff' } },
    { if: { colour: 'brand2' }, tokens: { color: '#394056' } },
    { if: { colour: 'brand3' }, tokens: { color: '#f39d80' } },
    { if: { colour: 'alternative1' }, tokens: { color: '#394056' } },
    { if: { colour: 'alternative2' }, tokens: { color: '#f39d80' } },
    { if: { colour: 'alternative3' }, tokens: { color: '#f9f2dd' } }
  ],
  tokens: {
    color: '#394056',
    fontName: 'SofiaPro',
    fontScaleCap: 64,
    fontSize: 18,
    fontWeight: '400',
    gradient: null,
    letterSpacing: 0,
    lineHeight: 1.55555555,
    superScriptFontSize: null,
    textTransform: 'none'
  }
}
export default theme
